import { makeStyles } from "@mui/styles";
import { inarixColors } from "inarix-theme";

export const useStyles = makeStyles({
  root: {
    width: 200,
    "& .MuiOutlinedInput-input": {
      color: "transparent",
    },
    "& .MuiInputLabel-root": {
      color: "#79777D",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "#F6F6F6",
    },
    "&:hover .MuiInputLabel-root": {
      color: inarixColors.light_inarix,
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "transparent",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "transparent",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
  },

  rootError: {
    width: 200,
    "& .MuiOutlinedInput-input": {
      color: "transparent",
    },
    "& .MuiInputLabel-root": {
      color: "#D32F2F",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "#F6F6F6",
    },
    "&:hover .MuiInputLabel-root": {
      color: inarixColors.light_inarix,
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "transparent",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "transparent",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
  },

  singleSelect: {
    width: 200,

    "& .MuiInputLabel-root": {
      color: "#79777D",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },

    "&:hover .MuiInputLabel-root": {
      color: inarixColors.light_inarix,
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "transparent",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "& .MuiAutocomplete-inputRoot": {
      color: "#79777D",
    },
  },

  singleSelectError: {
    width: 200,

    "& .MuiInputLabel-root": {
      color: "#D32F2F",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },

    "&:hover .MuiInputLabel-root": {
      color: inarixColors.light_inarix,
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "transparent",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },

    "& .MuiAutocomplete-inputRoot": {
      color: "#D32F2F",
    },
  },

  autoComplete: {
    "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
      transform: "translate(34px, 20px) scale(1);",
    },
    "&.Mui-focused .MuiInputLabel-outlined": {
      color: "purple",
    },
    "& .MuiAutocomplete-inputRoot": {
      color: "red",
      '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-of-type':
        {
          paddingLeft: 26,
        },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "green",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "red",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "purple",
      },
    },
  },
});

export const stylesMUIManagers = {
  CreateManagersButton: {
    textTransform: "none",
    width: "79px",
    marginTop: "24px",
  },

  columnsFormControl: {
    m: 1,
    width: 300,
    border: "none",
  },
  columnsFormControlBox: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.5,
  },
  InputLabel: {
    marginLeft: "-3px",
  },
  assignedSiteAutocomplete: {
    color: "red",
  },
  headAlert: {
    marginBottom: "2px",
  },

  StepConfigCreateManagerUsersForm: {
    background: "#fff",
  },
  StepConfigCreateManagerUsersFormBox:{
    height: 420, width: 1 
  }
};
